module.exports = __webpack_public_path__ + "img/switzerland-blood-diseases-male.aec219ef.png";